<template>
	<div class="m-price">
		<template v-if="groups.length">
			<div class="price-intro">
				<div class="intro-title">价格是怎么定的</div>
				<div class="intro-desc">
					外包公司的报价里通常有三到五成是销售和项目经理的成本。你直接找到写代码的人，
					省掉的就是这部分，所以同样的活我能便宜不少，而且不用担心需求在中间被传歪。
				</div>
			</div>

			<div class="price-group" v-for="group in groups" :key="group.category">
				<div class="group-head">{{ group.categoryName }}</div>
				<div class="price-item" v-for="item in group.items" :key="item.id">
					<div class="item-head">
						<div class="item-title">
							<span class="item-name">{{ item.name }}</span>
							<span class="item-duration" v-if="item.duration">{{ item.duration }}</span>
						</div>
						<span class="item-price">{{ priceText(item) }}</span>
					</div>
					<div class="item-desc" v-if="item.description">{{ item.description }}</div>
					<div class="item-features" v-if="featureList(item).length">
						<span class="feature" v-for="(f, i) in featureList(item)" :key="i">
							<i class="check icon"></i>{{ f }}
						</span>
					</div>
				</div>
			</div>

			<div class="price-process">
				<div class="group-head">怎么合作</div>
				<div class="step" v-for="(step, i) in steps" :key="i">
					<span class="step-index">{{ i + 1 }}</span>
					<div class="step-body">
						<div class="step-name">{{ step.name }}</div>
						<div class="step-desc">{{ step.desc }}</div>
					</div>
				</div>
			</div>

			<!-- 免责声明必须跟着价格一起出现 -->
			<div class="price-disclaimer">{{ disclaimer }}</div>

			<div class="price-cta">
				<span>说说你的需求，看到后我会尽快回复</span>
				<el-button type="primary" size="small" @click="$emit('go-lead')">提交需求</el-button>
			</div>
		</template>

		<div v-else class="price-empty">暂时没有可展示的内容，直接把需求发我，我按实际情况报</div>
	</div>
</template>

<script>
	const UNIT_TEXT = {元: '元', 元每小时: '元/小时', 元每天: '元/天'}

	export default {
		name: 'PriceTable',
		props: {
			// 由父组件统一请求：报价开关关闭时整个入口都不出现，组件自己请求会先闪一下
			groups: {
				type: Array,
				default: () => []
			},
			disclaimer: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				steps: [
					{name: '说需求', desc: '把想做的东西讲清楚，越具体我越好判断能不能接、要多久'},
					{name: '出方案', desc: '我给一个明确的功能清单、周期和报价，确认后再开始'},
					{name: '分期付', desc: '定金三成开工，中期四成，验收通过付尾款'},
					{name: '交源码', desc: '交付完整源代码和部署文档，后续维护不会被卡住'}
				]
			}
		},
		methods: {
			priceText(item) {
				const unit = UNIT_TEXT[item.priceUnit] || item.priceUnit || '元'
				const min = item.priceMin != null ? Number(item.priceMin) : null
				const max = item.priceMax != null ? Number(item.priceMax) : null
				if (min === null && max === null) {
					return '面议'
				}
				if (min !== null && max !== null && min !== max) {
					return `¥${min} - ${max} ${unit}`
				}
				return `¥${min !== null ? min : max} ${unit}`
			},
			featureList(item) {
				return item.features ? String(item.features).split('\n').filter((f) => f.trim()) : []
			}
		}
	}
</script>

<style scoped>
	.price-intro {
		padding: 14px 16px;
		border-radius: 6px;
		background: rgba(64, 158, 255, .06);
		margin-bottom: 18px;
	}

	.intro-title {
		font-size: 14px;
		font-weight: 500;
		color: rgba(0, 0, 0, .75);
		margin-bottom: 6px;
	}

	.intro-desc {
		font-size: 13px;
		line-height: 1.7;
		color: rgba(0, 0, 0, .6);
	}

	.group-head {
		font-size: 14px;
		font-weight: 500;
		color: rgba(0, 0, 0, .75);
		margin: 20px 0 10px;
		padding-bottom: 6px;
		border-bottom: 1px solid rgba(34, 36, 38, .08);
	}

	.price-item {
		padding: 12px 0;
		border-bottom: 1px dashed rgba(0, 0, 0, .06);
	}

	.item-head {
		display: flex;
		justify-content: space-between;
		align-items: baseline;
		flex-wrap: wrap;
		gap: 6px;
	}

	.item-name {
		font-size: 14px;
		color: rgba(0, 0, 0, .8);
	}

	.item-duration {
		font-size: 11px;
		color: #409eff;
		background: rgba(64, 158, 255, .1);
		padding: 1px 6px;
		border-radius: 8px;
		margin-left: 8px;
	}

	.item-price {
		font-size: 14px;
		font-weight: 500;
		color: #e6a23c;
		white-space: nowrap;
	}

	.item-desc {
		font-size: 12px;
		color: rgba(0, 0, 0, .45);
		margin-top: 5px;
		line-height: 1.5;
	}

	.item-features {
		display: flex;
		flex-wrap: wrap;
		gap: 4px 14px;
		margin-top: 7px;
	}

	.feature {
		font-size: 12px;
		color: rgba(0, 0, 0, .5);
	}

	.feature i {
		color: #67c23a;
		font-size: 11px !important;
		margin-right: 2px !important;
	}

	.step {
		display: flex;
		align-items: flex-start;
		padding: 7px 0;
	}

	.step-index {
		width: 20px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		border-radius: 50%;
		background: #409eff;
		color: #fff;
		font-size: 12px;
		flex-shrink: 0;
		margin-right: 10px;
	}

	.step-name {
		font-size: 13px;
		color: rgba(0, 0, 0, .75);
	}

	.step-desc {
		font-size: 12px;
		color: rgba(0, 0, 0, .45);
		margin-top: 2px;
		line-height: 1.5;
	}

	.price-disclaimer {
		margin-top: 18px;
		padding: 10px 12px;
		font-size: 12px;
		line-height: 1.6;
		color: rgba(0, 0, 0, .4);
		background: rgba(0, 0, 0, .02);
		border-radius: 4px;
	}

	.price-cta {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 10px;
		margin-top: 16px;
		padding-top: 14px;
		border-top: 1px solid rgba(34, 36, 38, .08);
		font-size: 13px;
		color: rgba(0, 0, 0, .6);
	}

	.price-empty {
		text-align: center;
		padding: 30px 0;
		color: rgba(0, 0, 0, .35);
		font-size: 13px;
	}
</style>
